import React from "react";
import { PARAGRAPH_TYPE_PRIMARY, PARAGRAPH_TYPE_TITLE, PARAGRAPH_TYPE_HIGHLIGHTS, PARAGRAPH_TYPE_SECONDARY } from "./constants";
import { getClassNames } from "../../utils";
import withTheme from "../../hocs/withTheme";
import "./Paragraph.css";

type ParagraphType =
    | typeof PARAGRAPH_TYPE_PRIMARY
    | typeof PARAGRAPH_TYPE_TITLE
    | typeof PARAGRAPH_TYPE_HIGHLIGHTS
    | typeof PARAGRAPH_TYPE_SECONDARY;

export interface ParagraphProps extends React.HTMLAttributes<HTMLParagraphElement> {
    type?: ParagraphType;
}

const Paragraph: React.FC<ParagraphProps> = ({
    type = PARAGRAPH_TYPE_PRIMARY,
    children = null,
    className = '',
    ...props
}) => {
    return (
        <p
            {...props}
            className={getClassNames(
                className,
                "Paragraph",
                `Paragraph_${type}`
            )}
        >
            {children}
        </p>
    );
};

export default withTheme(Paragraph);
